// SPEC-COLLECTION-OFFLINE-COMPLETE-01 (D-268i) PHASE_D D4/D5: 端末ストレージの永続化要求と逼迫監視。
//   未送信ドラフト(署名/写真 Blob 込み)を端末が勝手に消さないよう永続化を要求し、割当逼迫を画面警告できるようにする。
//   すべて best-effort(未対応ブラウザ/例外は握って null)=業務(集金)を止めない。

// D4: navigator.storage.persist() を要求する。セッションを跨いでリセットされる報告があるため毎回要求する。
//   返り値: 永続化が有効か(true/false)、未対応/失敗は null。
export async function requestPersistentStorage() {
  try {
    if (typeof navigator === 'undefined' || !navigator.storage?.persist) return null
    return await navigator.storage.persist()
  } catch {
    return null
  }
}

// D5: navigator.storage.estimate() で使用量/割当を見て逼迫(残り10%未満)を判定する。
//   返り値: { usage, quota, ratio, tight } または未対応/失敗時 null。tight=残り容量が割当の10%未満。
export async function getStorageEstimate() {
  try {
    if (typeof navigator === 'undefined' || !navigator.storage?.estimate) return null
    const est = await navigator.storage.estimate()
    const usage = Number(est?.usage ?? 0)
    const quota = Number(est?.quota ?? 0)
    const ratio = quota > 0 ? usage / quota : 0
    const tight = quota > 0 && (quota - usage) / quota < 0.1
    return { usage, quota, ratio, tight }
  } catch {
    return null
  }
}
